import(/* webpackMode: "eager", webpackExports: ["GetUpdatesForm"] */ "/opt/atlassian/pipelines/agent/build/apps/woundscantwait-com/src/_pages/get-updates/libs/components/get-updates-form/get-updates-form.tsx");
